import {ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {NavLink as RouterLink} from "react-router-dom";

const styles = {
    listItem: {
        display: 'block'
    },
    listItemButton: {
        minHeight: '2.25rem',
        justifyContent: 'initial',
        px: '0.5rem',
        py: '0.1rem',
    },
    listItemIcon: {
        minWidth: 0,
        mr: '1.5rem',
        justifyContent: 'center',
    }
};

export default function NavigationButton(props) {
    return (<ListItem disablePadding sx={styles.listItem}>
        <ListItemButton to={props.toLink} component={RouterLink} sx={styles.listItemButton}>
            <ListItemIcon sx={styles.listItemIcon}>
                {props.children}
            </ListItemIcon>
            <ListItemText primary={props.displayName} slotProps={{primary: {fontSize: '0.875rem'}}}/>
        </ListItemButton>
    </ListItem>);
}